export const UPDATE_SELECTED_COLUMNS = 'UPDATE_SELECTED_COLUMNS'
export const FETCH_SELECTED_COLUMNS = 'FETCH_SELECTED_COLUMNS'
export const STORE_SELECTED_COLUMNS = 'STORE_SELECTED_COLUMNS'
